import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BASE_URL } from "../../utils/BaseUrl"
import httpRequest from "../../utils/httpsRequest";

export const fetchComplaints = createAsyncThunk(
  "complaint/fetchComplaints",
  async (arg) => {
    return httpRequest(`${BASE_URL}/Compliant?Status=${arg.status}&Date=${arg.date}&SearchText=${arg.searchText}&PageSize=${arg.pageSize}&PageNumber=${arg.pageNumber}`);
  }
)

const complaintSlice = createSlice({
  name: 'complaint',
  initialState: {
    complaint: [],
    loading: false,
    error: null,
  },
  reducers:  {
    setcomplaint(state, action) {
      state.complaint.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchComplaints.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchComplaints.fulfilled, (state, action) => {
        state.loading = false;
        state.complaint = action.payload;
      })
      .addCase(fetchComplaints.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const { setComplaint } = complaintSlice.actions;
export default complaintSlice.reducer;

